<template>
    <div class="bg-white py-5">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-12">
          <h1 class="py-4">
            Because of our strong market position in over 20 countries, we
            expect to either go public or be acquired at a valuation of over $1
            billion
          </h1>
        </div>
        <div class="col-lg-6 p-0 overflow-hidden shadow-lg">
          <img
            class="rounded-lg-3 w-100"
            src="@/images/invest/position-comparison.png"
            alt=""
          />
        </div>
        <div class="col-lg-6 p-3 p-lg-5 pt-lg-3">
          <div class="mb-4">
            <h2>Carvana Valuation = $51 billion</h2>
            <div class="lead">
              Top used car sales technology/ internet company
            </div>
          </div>
          <div class="mb-4">
            <h2 class="fw-bold">
              OOYYO VALUATION - Expected to reach over $1 billion
            </h2>
            <div class="lead">
              For a limited time OOYYO will give investors the opportunity to
              invest in our top used car sales technology/internet company
            </div>
          </div>
          <div class="mb-4">
            <h2>TrueCar Valuation = $550 million</h2>
            <div class="lead">
              Top used car sales technology/ internet company
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>